<template>
  <b-row>

    <div class="col-6">
      <b-row>

        <div class="col-12">
          <label>Cobertura: <span class="text-danger">*</span></label>

          <b-form-radio-group 
            v-model="dataCita.cobertura" 
            :options="optsCoberturas" 
            value-field="value"
            text-field="text"
            :disabled="!canEditCobertura"
          />

          <small class="text-danger" v-if="errors.cobertura.length">
            {{ errors.cobertura[0] }}
          </small>
        </div>

        <div v-if="dataCita.cobertura" class="col-12 mt-2">
          <h5>Cobertura: <span class="text-success">{{ textoCobertura }}</span></h5>
        </div>


        <div class="col-12 d-flex align-items-center mt-2" v-if="canViewEsDerivado">
          <label>Es derivado de otro prestador: </label>
          <b-form-checkbox 
            v-model="dataCita.esDerivado" 
            switch 
            class="ml-2"
          />
          <span style="width: 20px">{{ dataCita.esDerivado ? 'Si' : 'No' }}</span>
        </div>


        <div class="col-12 my-2" v-if="dataCita.cobertura">
          <label>Tipo de servicio: <span class="text-danger">*</span></label>
          <b-form-radio-group 
            v-model="dataCita.grupoServicios" 
            :options="optsGrupoServicios" 
            value-field="value"
            text-field="text"
            :disabled="!canSelectTipoServicio"
          />

          <!-- <b-form-radio-group 
            v-model="dataCita.tipoServicio" 
            :options="optsServicios" 
            value-field="value"
            text-field="text"
            :disabled="!canSelectTipoServicio"
          /> -->

        </div>


        <div class="col-12" v-if="dataCita.grupoServicios === '2'">

          <b-form-radio-group
            v-if="!esCoberturaParticular"
            v-model="dataCita.tipoServicios"
            :options="optsServicios"
            value-field="value"
            text-field="text"
            stacked
          />

          <b-form-checkbox-group
            v-if="esCoberturaParticular"
            v-model="dataCita.tipoServicios"
            :options="optsServicios"
            value-field="value"
            text-field="text"
            stacked
          />

        </div>
        
        <small class="text-danger" v-if="errors.tipoServicios.length">
          {{ errors.tipoServicios[0] }}
        </small>

        <div class="col-12 d-flex align-items-center mt-2" v-if="dataCita.grupoServicios === '2'">
          <label>Marcar como contrareferencia: </label>
          <b-form-checkbox 
            v-model="dataCita.esContrareferencia" 
            switch 
            class="ml-2"
          />
          <span style="width: 20px">{{ dataCita.esContrareferencia ? 'Si' : 'No' }}</span>
        </div>

        <div v-if="dataCita.esDerivado" class="col-10 my-1">
          <label>Codigo de derivacion: <span class="text-danger">*</span></label>
          <b-form-input 
            v-model="dataCita.codigoDerivacion" 
            placeholder="Ingrese el codigo de la derivacion"
          />

          <small class="text-danger" v-if="errors.codigoDerivacion.length">
            {{ errors.codigoDerivacion[0] }}
          </small>
            
        </div>

        <div v-if="dataCita.esDerivado" class="col-10">
          <label>Fecha de Derivacion: <span class="text-danger">*</span></label>
          <flat-pickr 
            v-model="dataCita.fechaDerivacion" 
            class="form-control" 
            :config="{ dateFormat: 'Y-m-d' }" 
          />

          <small class="text-danger" v-if="errors.fechaDerivacion.length">
            {{ errors.fechaDerivacion[0] }}
          </small>
        </div>

        <div v-if="dataCita.esDerivado" class="col-10 mt-1">
          <label>Fecha fin de vigencia: <span class="text-danger">*</span></label>
          <flat-pickr
            v-model="dataCita.fechaFinDerivacion"
            class="form-control"
            :config="{ dateFormat: 'Y-m-d' }"
          />

          <small class="text-danger" v-if="errors.fechaFinDerivacion.length">
            {{ errors.fechaFinDerivacion[0] }}
          </small>
        </div>

        <div v-if="showAlertaDerivacionCaducada" class="col-10 mt-2">
          <b-alert show variant="danger" class="mb-0">
            La derivacion se encuentra caducada. Fecha fin de vigencia: {{ dataCita.fechaFinDerivacion }}
          </b-alert>
        </div>


      </b-row>
    </div>

    <div class="col-6" v-if="dataCita.cobertura">
      <b-row>

        <div class="col-12 my-1">
          <label>Paciente: <span class="text-danger">*</span></label>
          <SearchOpts
            v-model="dataCita.paciente"
            :searchService="pacientesService.searchPacientesByTermSelect"
            :placeholder="'Buscar por nombre o cedula el paciente...'"
          />


          <small class="text-danger" v-if="errors.paciente.length">
            {{ errors.paciente[0] }}
          </small>
        </div>

        <div class="col-12 my-1" v-if="dataCita.tipoServicios.includes('1')">
          <label>Doctor: <span class="text-danger">*</span></label>
          <SearchOpts
            v-model="dataCita.doctor"
            :searchService="doctoresService.searchDoctoresByTermSelect"
            :placeholder="'Buscar doctor por nombre...'"
          />

          <small class="text-danger" v-if="errors.doctor.length">
            {{ errors.doctor[0] }}
          </small>
        </div>

        <b-col md="6" v-if="canShowFechaCita">
          <label>Fecha de la cita: <span class="text-danger">*</span></label>
          <flat-pickr 
            v-model="dataCita.fechaCita" 
            class="form-control"
            :config="fechaCitaConfig"
            :disabled="!canEditFechaCita"
            :class="{ 'is-invalid': errors.fechaCita.length }"
          />
          <small class="text-danger" v-if="errors.fechaCita.length">
            {{ errors.fechaCita[0] }}
          </small>
        </b-col>

        <b-col md="6" v-if="dataCita.tipoServicios.includes('1')">
          <label>Hora de la cita: <span class="text-danger">*</span></label>
          <flat-pickr 
            v-model="dataCita.horaCita" 
            class="form-control"
            :config="{ enableTime: true, noCalendar: true, dateFormat: 'H:i:ss', }"
            :class="{ 'is-invalid': errors.length > 0 }" 
          />
          <small class="text-danger" v-if="errors.horaCita.length">
            {{ errors.horaCita[0] }}
          </small>
        </b-col>


        <b-col cols="12" v-if="dataCita.tipoServicios.includes('1')" class="mt-1">
          <label>Tipo de Contingencia:<span class="text-danger">*</span></label>

          <v-select 
            id="v-type-insurance" 
            v-model="dataCita.tipoContingencia"
            :class="{ 'is-invalid': errors.length > 0 }" 
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="optsTipocontingencia" 
            label="text" 
          />

          <small class="text-danger" v-if="errors.tipoContingencia.length">
            {{ errors.tipoContingencia[0] }}
          </small>

        </b-col>

      </b-row>
    </div>
  </b-row>

</template>

<script>
import { pacientesService, segurosService } from "@/views/admision/services";
import { doctoresService }  from "@/views/administracion/services";
import { citasService }     from "@/views/citas/services";
import { SearchOpts } from '@/shared/components';
import flatPickr from 'vue-flatpickr-component';
import vSelect from 'vue-select';
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import "flatpickr/dist/flatpickr.css";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "vue2-timepicker/dist/VueTimepicker.css";
import { getItemByValueId } from "../../../../shared/helpers";
import { derivacionesService } from "../../../derivaciones/services";
import { ROLES } from '@/shared/constants';

const ALLOWED_ROLES_EDIT_FECHA = [ROLES.JEFE_MEDICO, ROLES.JEFE_VALIDACIONES];

export default {

  name: 'CitaInfo',

  components: {
    SearchOpts,
    flatPickr,
    vSelect
  },

  async created() {
    this.loadUserRoles();
    await this.fetchTipoContingencia();
    this.optsCoberturas = await segurosService.getTiposCoberturaSelect();
    await this.loadDataSave();
    if (!this.tokenCita && this.isInitializing) this.isInitializing = false;
  },


  data() {
    return {
      
      tokenCita: null,
      isInitializing: true,
      usuarioRoles: [],
      fechaCitaConfig: {
        dateFormat: 'Y-m-d'
      },

      pacientesService,
      doctoresService,

      dataCita: {
        cobertura          : null,
        grupoServicios     : null,
        tipoServicios      : [],
        esDerivado         : false,
        esContrareferencia : false,
        codigoDerivacion   : null,
        fechaDerivacion    : null,
        fechaFinDerivacion : null,
        derivacionCaducada : false,
        paciente           : null,
        doctor             : null,
        horaCita           : null,
        fechaCita          : null,
        tipoContingencia   : null,
        estadoCita         : null,
        estadoActual       : null,
        estadoRevision     : null,
        estadoSignosVitales: null,
        fechaIngreso       : null,
        establecimientoId  : null
      },

      errors:{
        cobertura        :[],
        tipoServicios    :[],
        codigoDerivacion :[],
        fechaDerivacion  :[],
        fechaFinDerivacion: [],
        paciente         :[],
        doctor           :[],
        horaCita         :[],
        fechaCita        :[],
        tipoContingencia :[],
      },


      optsCoberturas: [],
      optsTipocontingencia: [],

      optsServicios: [
        // { value: '1', text: 'Atención' }, 
        { value: '2', text: 'Imagenes' }, 
        { value: '3', text: 'Laboratorios' },
        { value: '4', text: 'Procedimientos' },
        { value: '5', text: 'Terapias' },
        { value: '6', text: 'Medicamentos' },
      ],


      optsGrupoServicios: [
        { value: '1', text: 'Atención' }, 
        { value: '2', text: 'Otros Servicios' }, 
        { value: '3', text: 'Combos' },
      ],
    }
  },


  methods:{

    loadUserRoles(){
      const detalleUsuario = localStorage.getItem('detalleusuario');
      if(!detalleUsuario) return;

      try {
        const { roles } = JSON.parse(detalleUsuario);
        this.usuarioRoles = Array.isArray(roles) ? roles : [];
      } catch (error) {
        console.error('Error al obtener los roles del usuario', error);
        this.usuarioRoles = [];
      }
    },

    async loadDataSave() {
      
      this.tokenCita = this.$route.params.token;
      if(!this.tokenCita) return;

      const responseCita = await citasService.getByToken(this.tokenCita);

      console.log('response cita', responseCita);

      if(!responseCita){
        console.error('Cita no encontrada');
        this.isInitializing = false;
        return;
      }
      
      const cedulaPaciente = responseCita.paciente.persona.identificacion;
      const cobertura      = responseCita.cobSeleccionada?.id;
      const tipoServicios  = responseCita.tipoServicios ? JSON.parse(responseCita.tipoServicios) : []; 

      let grupoServicios = null;

      if(tipoServicios.includes('1')) grupoServicios = '1';

      if(['2', '3', '4'].some(s => tipoServicios?.includes(s))) 
        grupoServicios = '2';

      const tipoServiciosMap = (cobertura === '5') ? tipoServicios : tipoServicios[0] 

      const searchPacientes = await pacientesService.searchPacientesByTermSelect(cedulaPaciente)
      const paciente = searchPacientes[0];

      const doctor = tipoServicios.includes('1')
        ? { value:responseCita.doctor.id, text: `${responseCita.doctor.idPersona.primerApellido} ${responseCita.doctor.idPersona.primerNombre}` }
        : null;

      const tipoContingencia = getItemByValueId(this.optsTipocontingencia, responseCita.tipocontingencia.id);

      const esDerivado = responseCita.derivacion === '1';

      const responseDerivaciones = await derivacionesService.getAll({ tokenCita: this.tokenCita });
      const contrareferencia = esDerivado && grupoServicios === '2' && !!responseDerivaciones?.derivaciones.length;


      const fechaCita = this.esEditar ? (responseCita?.fechaCita || null) : null;

      const responseCitaMap = {
        cobertura        : responseCita.cobSeleccionada?.id,
        esDerivado       : esDerivado,
        grupoServicios   : grupoServicios,
        tipoServicios    : tipoServiciosMap,
        codigoDerivacion : responseCita.codderivacion || null,
        fechaDerivacion  : responseCita.fecderivacion || null,
        fechaFinDerivacion: responseCita.fecfinderivacion || null,
        derivacionCaducada: !!responseCita.derivacionCaducada,
        paciente         : paciente,
        doctor           : doctor,
        horaCita         : responseCita.horaCita,
        tipoContingencia : tipoContingencia,
        esContrareferencia : contrareferencia,
        fechaCita,
        estadoCita         : responseCita.estado?.toString() || null,
        estadoActual       : responseCita.estadoActual?.toString() || null,
        estadoRevision     : responseCita.estadoRevision?.toString() || null,
        estadoSignosVitales: responseCita.estadoSignosvital?.toString() || null,
        fechaIngreso       : responseCita.fechaIngreso || null,
        establecimientoId  : responseCita.establecimiento?.id || null
      }

      
      this.dataCita = responseCitaMap;
      console.log('this.dataCita', this.dataCita);
      this.$nextTick(() => {
        this.isInitializing = false;
      });
    },


    async fetchTipoContingencia() {
      const query = `
        query MyQuery {
          allTipocontingencia {
            descripcion
            id
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        this.optsTipocontingencia = response.data.data.allTipocontingencia.map(
          (item) => ({
            value: item.id,
            text: item.descripcion,

          })
        );
      } catch (error) {
        console.error("Ocurrion un error al traer los tipos de contingencia:", error);
      }
    },


    async validationDataCita() {

      return new Promise( async (resolve, reject) => {

        this.errors = {
          cobertura        : [],
          tipoServicios    : [],
          codigoDerivacion : [],
          fechaDerivacion  : [],
          fechaFinDerivacion: [],
          paciente         : [],
          doctor           : [],
          horaCita         : [],
          fechaCita        : [],
          tipoContingencia : [],
        };

        if(!this.dataCita.cobertura){
          this.errors.cobertura.push('Campo cobertura es obligatorio');
        }


        if(this.dataCita.esDerivado){
          
          if(!this.dataCita.codigoDerivacion)
            this.errors.codigoDerivacion.push('Campo codigo derivacion es obligatorio');

          if(!this.dataCita.fechaDerivacion)
            this.errors.fechaDerivacion.push('Campo fecha derivacion es obligatorio');

          if(!this.dataCita.fechaFinDerivacion)
            this.errors.fechaFinDerivacion.push('Campo fecha fin de vigencia es obligatorio');

          if(this.dataCita.fechaDerivacion && this.dataCita.fechaFinDerivacion) {
            if (this.dataCita.fechaFinDerivacion < this.dataCita.fechaDerivacion)
              this.errors.fechaFinDerivacion.push('La fecha fin de vigencia no puede ser menor a la fecha de derivacion');
          }

          if(this.showAlertaDerivacionCaducada)
            this.errors.fechaFinDerivacion.push('La derivacion se encuentra caducada');
        }

        if(!this.dataCita.tipoServicios.length){
          this.errors.tipoServicios.push('Campo tipo servicio es obligatorio');
        }


        if(this.dataCita.tipoServicios.includes('1')){

          if(!this.dataCita.doctor)
            this.errors.doctor.push('Campo doctor es obligatorio');

          if(this.canShowFechaCita && !this.dataCita.fechaCita)
            this.errors.fechaCita.push('Campo fecha cita es obligatorio');

          if(!this.dataCita.horaCita)
            this.errors.horaCita.push('Campo hora cita es obligatorio');

          if(!this.dataCita.tipoContingencia)
            this.errors.tipoContingencia.push('Campo tipo contigencia es obligatorio');
        }

        if(!this.dataCita.paciente){
          this.errors.paciente.push('Campo paciente es obligatorio');
        }  
        
        
        if(this.dataCita.grupoServicios > '4'){
          this.$swal.fire({
            title: 'El tipo de servicio no esta disponible',
            icon: 'error',
          });

          reject();
          return;
        }


        // las validaciones al editar
        if(this.esEditar ){

          if(this.dataCita.esDerivado && !this.dataCita.esContrareferencia){

            const responseDerivaciones = await derivacionesService.getAll({ tokenCita: this.tokenCita });

            if(responseDerivaciones?.derivaciones.length){
              this.$swal.fire({
                title: 'La cita tiene derivacion de contrareferencia creada',
                icon: 'error',
              })

              this.dataCita.esContrareferencia = true;

              reject();
              return;
            }
          }
        }


        if(
          this.errors.cobertura.length 
          || this.errors.paciente.length 
          || this.errors.doctor.length
          || this.errors.fechaCita.length
          || this.errors.horaCita.length
          || this.errors.codigoDerivacion.length
          || this.errors.fechaDerivacion.length
          || this.errors.fechaFinDerivacion.length
          || this.errors.tipoContingencia.length
          || this.errors.tipoServicios.length
        ){

          this.$swal.fire({
            title: 'Datos incompletos',
            icon: 'error',
            text: 'Debe ingresar los campos obligatorios'
          });

          reject();
          return;
        }

        // validar citas con horarios de doctores
        if(this.dataCita.tipoServicios.includes('1')){

          // const isCitaRepetida = await this.validateCitaRepetida();
          // const isHorarioOcupadoDoctor = await this.validateHorarioDoctor();

          // if(isCitaRepetida || isHorarioOcupadoDoctor){
          //   reject();
          //   return;
          // }
        }

        resolve(true);

      });
    },



    async validateCitaRepetida() {

      const fechaHoy = this.getHoy();

      const params = {
        pacienteId  : this.dataCita.paciente?.value,
        doctorId    : this.dataCita.doctor?.value,
        cobertura   : this.dataCita.cobertura,
        fechaDesde  : fechaHoy,
      }

      const responseCitas = await citasService.getAll(params);

      if(!responseCitas) return false;

      const hasRepetidas = this.tokenCita
        ? responseCitas.data.some(item => item.token !== this.tokenCita)
        : responseCitas.total > 0;
      
      // const hasRepetidas = responseCitas.total > 0;

      if(hasRepetidas){
        await this.$swal.fire({
          icon: 'info',
          width: '600px',
          html: `
            <div style="text-align: left;">
              <h4>Ya existe una cita programada con los siguientes datos:</h4>
              <strong>Paciente:</strong> ${this.dataCita.paciente.text}<br>
              <strong>Doctor:</strong> ${this.dataCita.doctor.text}<br>
              <strong>Cobertura:</strong> ${this.textoCobertura}<br>
              <strong>Fecha:</strong> ${fechaHoy}<br>
              
            </div>
          `
        })
      }

      return hasRepetidas  
    },



    async validateHorarioDoctor() {

      const params = {
        doctorId    : this.dataCita.doctor?.value,
        cobertura   : this.dataCita.cobertura,
        fechaDesde  : this.getHoy(),
      }

      const responseCitas = await citasService.getAll(params);
      if (!responseCitas) return false;

      const citasDoctor = responseCitas.data
      if (!citasDoctor) return false;

      if(this.tokenCita) return false;

      const horasOcupadasDoctor = citasDoctor.map( c => c.horaCita )

      const isHorarioOcupado = horasOcupadasDoctor.some( hora => hora === this.dataCita.horaCita );

      if(isHorarioOcupado){
        await this.$swal.fire({
          title: 'Horario ocupado..',
          icon: 'info',
          text: `El doctor ${this.dataCita.doctor.text} tiene una citas programadas para el dia de hoy en los siguientes horarios: ${horasOcupadasDoctor.join(", ")} `
        })
      }
      
      return isHorarioOcupado;
    },


    getHoy() {
      const hoy = new Date();
      const yyyy = hoy.getFullYear();
      const mm = String(hoy.getMonth() + 1).padStart(2, '0');
      const dd = String(hoy.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },
  },


  computed:{
    canViewEsDerivado(){
      const coberturaCorrecta = this.dataCita.cobertura && this.dataCita.cobertura < 4;
      return coberturaCorrecta
    },

    canShowFechaCita(){
      if(!this.esEditar) return false;

      const servicios = this.dataCita?.tipoServicios;
      if(Array.isArray(servicios)) return servicios.includes('1');
      return typeof servicios === 'string' ? servicios.includes('1') : false;
    },

    canEditFechaCita(){
      if(!this.canShowFechaCita) return false;
      return this.usuarioRoles.some(rol => ALLOWED_ROLES_EDIT_FECHA.includes(rol?.codigo));
    },

    canSelectTipoServicio() {

      if(this.tokenCita && !this.canEditCobertura) return false;

      const coberturaCorrecta = this.dataCita.cobertura > 3;
      const esDerivacion      = this.dataCita.esDerivado;

      return coberturaCorrecta || esDerivacion;
    },

    textoCobertura() {
      const tipoCobertura = this.dataCita.cobertura;
      return tipoCobertura === '1' 
        ? 'IESS' 
        : tipoCobertura === '2' 
          ? 'ISSPOL' 
          : tipoCobertura === '3' 
            ? 'ISSFA'
            : tipoCobertura === '4'
              ? 'MSP'
              : tipoCobertura === '5'
                ? 'PARTICULAR'
                : tipoCobertura === '6'
                  ? 'PRIVADO'
                  : ''
    },



    esCoberturaIess() {
      return this.dataCita.cobertura === '1';
    },

    esCoberturaParticular() {
      return this.dataCita.cobertura === '5';
    },

    esEditar(){
      return this.$route.params.token
    },
    canEditCobertura(){
      if(!this.tokenCita) return true;
      return this.usuarioRoles.some(rol => ALLOWED_ROLES_EDIT_FECHA.includes(rol?.codigo));
    },

    showAlertaDerivacionCaducada() {
      if(!this.dataCita.esDerivado || !this.dataCita.fechaFinDerivacion) return false;

      const fechaFin = new Date(`${this.dataCita.fechaFinDerivacion}T00:00:00`);
      if(Number.isNaN(fechaFin.getTime())) return false;

      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);
      return fechaFin < hoy;
    }
  },


  watch:{

    dataCita:{
      deep: true,
      handler(newValue){
        this.$store.commit('setDataInfoCita', newValue);
      }
    },


    'dataCita.cobertura': {
      handler(newVal){

        if(this.isInitializing) return;
        if(this.tokenCita && !this.canEditCobertura) return;
        this.dataCita.esDerivado = false
        this.dataCita.grupoServicios = '1'
      }
    },


    'dataCita.grupoServicios':{
      handler(newValue){

        if(this.isInitializing) return;
        if(this.tokenCita && !this.canEditCobertura) return;

        this.dataCita.tipoServicios = [];
        if(newValue === '1') this.dataCita.tipoServicios = ['1'];

        if(newValue !== '1'){
          this.dataCita.doctor = null;
          this.dataCita.horaCita = null;
          this.dataCita.tipoContingencia = null;
          this.dataCita.fechaCita = null;
        }

        if(newValue === '3'){
          this.dataCita.tipoServicios = ['7']
        }
      }
    },



    'dataCita.esDerivado':{
      handler(newValue){

        if(this.isInitializing) return;
        if(this.tokenCita && !this.canEditCobertura) return;

        this.dataCita.codigoDerivacion = null;
        this.dataCita.fechaDerivacion = null;
        this.dataCita.fechaFinDerivacion = null;
        this.dataCita.derivacionCaducada = false;
      }
    },


    
  }

}
</script>
